import React from 'react';
import { PayoutDialog as SharedPayoutDialog } from '@shared/components/PayoutDialog/PayoutDialog';
import { useCreditCardSetupTelemetry } from '../CreditCardSetUp.telemetry';
import type { PayoutAccountInfo } from '../CreditCardSetUp.context';
import type { RegistryPayoutAccountExternalAccountPayoutMethod } from '@graphql/generated-base';
import type { PayoutMethod, PayoutDialogStep, PayoutStatus } from '@shared/components/PayoutDialog/PayoutDialog.types';

export type { PayoutStatus };

interface PayoutDialogProps {
  readonly isOpen: boolean;
  readonly onClose: () => void;
  readonly payoutAccountInfo: PayoutAccountInfo;
  readonly dialogStep: PayoutDialogStep;
  readonly amountInMinorUnits: number;
  readonly onAmountChange: (amount: number) => void;
  readonly onContinue: () => void;
  readonly onBack: () => void;
  readonly selectedMethod: RegistryPayoutAccountExternalAccountPayoutMethod;
  readonly onMethodChange: (method: RegistryPayoutAccountExternalAccountPayoutMethod) => void;
  readonly onTransfer: () => void;
  readonly loadingTransfer: boolean;
  readonly status: PayoutStatus;
  readonly onConnectBank?: () => void;
  readonly onBankPromoViewed?: (partner: string) => void;
  readonly onBankPromoInteracted?: (cta: string, partner: string) => void;
}

export const PayoutDialog: React.FC<PayoutDialogProps> = ({ selectedMethod, onMethodChange, ...props }) => {
  const telemetry = useCreditCardSetupTelemetry();
  return (
    <SharedPayoutDialog
      {...props}
      selectedMethod={selectedMethod as PayoutMethod}
      onMethodChange={method => onMethodChange(method as RegistryPayoutAccountExternalAccountPayoutMethod)}
      onStatusDone={status => telemetry.closePayoutDialogStatusButtonClicked(status)}
    />
  );
};
